export * from './ubiMsgCenter.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMsgCenter/index.ts